<template>
  <footer class="site-footer">
    <div>{{ encryptReminder }}</div>
    <div class="footer-links">
      <a v-if="brand.securityContact" :href="'mailto:' + brand.securityContact">{{ brand.securityContact }}</a>
      <a href="/.well-known/pgp-key.asc">{{ t('footerPgp') }}</a>
      <span v-if="pgpKeyId || pgpFingerprint" class="footer-pgp-ids">
        <span v-if="pgpKeyId">{{ t('pgpKeyId') }} {{ pgpKeyId }}</span>
        <span v-if="pgpFingerprint">{{ t('pgpFingerprint') }} {{ pgpFingerprint }}</span>
      </span>
    </div>
  </footer>
</template>
<script>
import { t } from '../i18n'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'site-footer',
  computed: {
    ...mapState(['locale', 'brand']),
    ...mapGetters(['encryptReminder', 'pgpKeyId', 'pgpFingerprint'])
  },
  methods: {
    t(key) {
      return t(this.locale, key)
    }
  }
}
</script>
